import { ImageScaleView, View } from '@play-co/timestep-core/ui';
import { gsap } from 'gsap';

interface MascotConfig {
  image: string;
  width: number;
  height: number;
  x: number;
  y: number;
}

export default class Match2Mascots extends View {
  private mascots: ImageScaleView[] = [];

  constructor({
    superview,
    config,
  }: {
    superview: View;
    config: MascotConfig[];
  }) {
    super({
      superview,
      centerOnOrigin: true,
      centerAnchor: true,
    });

    config.forEach((mascot) => {
      const mascotView = new ImageScaleView({
        superview: this,
        ...mascot,
        centerOnOrigin: true,
        anchorX: 0.5 * mascot.width,
        anchorY: 0.85 * mascot.height,
        x: mascot.x,
        y: mascot.y,
      });

      this.mascots.push(mascotView);
    });

    this.style.y = 100;
  }

  public override async show() {
    super.show();
    gsap.to(this.style, {
      duration: 1.2,
      y: 0,
      ease: 'back.out',
    });

    this.mascots.forEach((mascot, i) => {
      gsap.to(mascot.style, {
        duration: 1.3,
        r: Math.PI * 0.05 * (i === 0 ? 1 : -1),
        ease: 'quad.inOut',
        yoyo: true,
        repeat: -1,
      });

      gsap.to(mascot.style, {
        duration: 1.2,
        y: mascot.style.y + 10,
        ease: 'quad.inOut',
        yoyo: true,
        repeat: -1,
      });
    });
  }

  public override async hide() {
    this.mascots.forEach((mascot) => gsap.killTweensOf(mascot.style));
    super.hide();
  }
}
